namespace Areas.Dialogs.AddDefaultJob {
    "use strict";

    let employeeId: number;

    export class AddDefaultJobDialog extends Areas.BaseDialog {
        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any = null) {
            super("AddDefaultJob", closeHandler, parameters, () => {
                employeeId = parameters.employeeId;
            })
        }

        protected ok = (e: any) => {
            const accountWorkOrdersGrid: DevExpress.ui.dxDataGrid = $("#AccountWorkOrdersGrid").dxDataGrid("instance");
            const taskOrdersGrid: DevExpress.ui.dxDataGrid = $("#TaskCodesGrid").dxDataGrid("instance");

            const accountWorkOrderId = accountWorkOrdersGrid.getSelectedRowKeys()[0];
            const taskCodeLk = taskOrdersGrid.getSelectedRowKeys()[0];

            if (accountWorkOrderId == null || taskCodeLk == null) {
                DevExpress.ui.notify("You need to select both a work order and a task code!", "warning", 2000);
            } else {
                const values = {
                    employeeId: employeeId,
                    accountWorkOrderId: accountWorkOrderId,
                    taskCodeLk: taskCodeLk
                };

                const url = "/Dialog/AddDefaultJob/Post/";
                Areas.sendRequest(url, JSON.stringify(values), "POST").done(() => this.close(DialogResult.Ok, null));
            }
        }
   }
   
}

